'use client';

import { createZustandStore } from '../../zustand';
import { IDeviceAssessmentState } from './types';
import {
  loadPersistedFeatureAssessmentStore,
  persistFeatureAssessmentStore,
} from './callback';

/**
 * This creates a local state tracker for device functional assessment results
 * and update callbacks to track and update the state.
 *
 * TODO: @Dinesh - Please extract out the logic into callback functions.
 * TODO: @Dinesh - Please refer to the other stores for context.
 */
export const useDeviceAssessmentStore =
  createZustandStore<IDeviceAssessmentState>((set) => {
    // Loads initial state from persisted storage
    const persistedState = loadPersistedFeatureAssessmentStore();

    const defaultValues = {
      assessments: null,
      currentAssessmentStep: 0,
      evaluationId: null,
    };

    // Initialize state with persisted state or default values
    const initialState: IDeviceAssessmentState = {
      assessments: persistedState?.assessments || null,
      currentAssessmentStep: persistedState?.currentAssessmentStep ?? 0,
      evaluationId: persistedState?.evaluationId ?? null,
      onUpdateFeatureAssessment: (feature) => {
        set((state) => {
          const oldAssessments = state.assessments || [];
          const indexToUpdate = oldAssessments.findIndex(
            (item) => item.component === feature.component
          );

          if (indexToUpdate !== -1) {
            const newFeatures = [...oldAssessments];
            newFeatures[indexToUpdate] = feature;
            if (state.evaluationId) {
              persistFeatureAssessmentStore({
                ...state,
                assessments: newFeatures,
              }); // Persist updated state
            }
            return { assessments: newFeatures };
          }
          const newAssessments = [...oldAssessments, feature];
          if (state.evaluationId) {
            persistFeatureAssessmentStore({
              ...state,
              assessments: newAssessments,
            }); // Persist updated state
          }
          return { assessments: newAssessments };
        });
      },
      onUpdateEvaluationId: (evaluationId) =>
        set(() => ({ evaluationId: evaluationId ?? null })),
      onUpdateCurrentAssessmentStep: (step) =>
        set(() => ({ currentAssessmentStep: step ?? 0 })),
      onResetDeviceAssessmentStore: (evaluationId) => {
        persistFeatureAssessmentStore({
          ...defaultValues,
          evaluationId,
        });

        set(() => ({ ...defaultValues, evaluationId }));
      },
    };

    return initialState;
  });
